/**
 * Replay recording and serialization.
 * Records every turn's actions and battle state for post-battle review.
 */

import type { BattleConfig, TrainerProfile, PokemonSet, PlayerAction, BattleState, Replay, ReplayTurn } from "./types";
import { APP_VERSION } from "../config/constants";

/** Replay recorder that accumulates turns as the battle progresses. */
export class ReplayRecorder {
  private config: BattleConfig;
  private p1Profile: TrainerProfile;
  private p2Profile: TrainerProfile;
  private p1Team: PokemonSet[];
  private p2Team: PokemonSet[];
  private turns: ReplayTurn[] = [];
  private initialState: BattleState | null = null;

  constructor(config: BattleConfig, p1: TrainerProfile, p2: TrainerProfile, teamA: PokemonSet[], teamB: PokemonSet[]) {
    this.config = config;
    this.p1Profile = p1;
    this.p2Profile = p2;
    this.p1Team = teamA;
    this.p2Team = teamB;
  }

  setInitialState(state: BattleState): void {
    this.initialState = state;
  }

  recordTurn(turn: number, actions: PlayerAction[], stateAfter: BattleState): void {
    this.turns.push({ turn, actions, stateAfter });
  }

  export(): Replay {
    if (!this.initialState) {
      throw new Error("Cannot export replay: initial state was not recorded");
    }
    return {
      version: APP_VERSION,
      config: this.config,
      p1Profile: this.p1Profile,
      p2Profile: this.p2Profile,
      p1Team: this.p1Team,
      p2Team: this.p2Team,
      initialState: this.initialState,
      turns: this.turns,
      createdAt: new Date().toISOString(),
    };
  }

  toJSON(): string {
    return JSON.stringify(this.export(), null, 2);
  }
}
